module.exports = __webpack_public_path__ + "static/media/halo-fix-illus.cc08e2c4.svg";